const serverConfig = {
  baseURL: "https://jltest.youzhiapp.com", // 测试
  // baseURL: "https://jltest-yu.youzhiapp.com", // 预上线 正式库
  // baseURL: "http://192.168.31.100:8099",
  // baseURL: "https://jielong.huolieyun.com", // 正式

  useTokenAuthorization: true, // 是否开启 token 认证
};
export default serverConfig;
